var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#25d366"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14025",
    "data-name": "Path 14025",
    className: "cls-2",
    d: "M9 4.64a1.28 1.28 0 0 0-.64.78 1.15 1.15 0 0 0 .34 1.09l.3.23a.73.73 0 0 1 0 .41v.36h-.43a1.94 1.94 0 0 0-1.32.64c-.47.53-.47.54-.45 4.51v3.52l.18.33a1.82 1.82 0 0 0 .85.84 2.36 2.36 0 0 0 1.17.22h.81v.81c0 .71 0 .84.12.93s.12.27 2.31-1.12l.93-.6h2.72l.37-.21a2.25 2.25 0 0 0 .58-.48c.41-.54.42-.61.42-4.34 0-3.29 0-3.39-.14-3.77a2.13 2.13 0 0 0-1-1.07 3.2 3.2 0 0 0-.67-.14L15 7.5v-.37c0-.37 0-.38.2-.51a1.1 1.1 0 0 0 .51-1 1 1 0 0 0-.56-.87 1.06 1.06 0 0 0-1.46.4 1 1 0 0 0-.15.48 1.09 1.09 0 0 0 .5 1c.21.12.22.14.22.53v.4H9.81v-.44c0-.39 0-.43.16-.5a1.11 1.11 0 0 0 .45-1.42A1.15 1.15 0 0 0 9 4.64zM10.74 10c.52.35.71 1 .36 1.22a.33.33 0 0 1-.47-.06.35.35 0 0 1-.06-.17.43.43 0 0 0-.47-.39c-.16 0-.2.07-.29.32s-.38.49-.6.3 0-1.07.53-1.31a1.36 1.36 0 0 1 1 .09zm3.73 0c.52.35.7 1 .35 1.23-.16.1-.19.1-.35 0a.4.4 0 0 1-.19-.27.41.41 0 0 0-.45-.37c-.18 0-.24.08-.34.42a.34.34 0 0 1-.55.2c-.33-.3 0-1.07.53-1.31a1.36 1.36 0 0 1 1 .09zm-4.64 3.82a5.38 5.38 0 0 0 2.17.38 5.05 5.05 0 0 0 2.14-.35c.5-.2.53-.2.69-.1a.35.35 0 0 1 .11.49 5 5 0 0 1-1.82.64 6.78 6.78 0 0 1-3.7-.47c-.25-.11-.31-.17-.32-.35a.29.29 0 0 1 .13-.32c.19-.13.17-.14.61.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14026",
    "data-name": "Path 14026",
    className: "cls-2",
    d: "M5.13 10.68c-.43.25-.53.53-.55 1.58a2.85 2.85 0 0 0 .09 1.23 1.06 1.06 0 0 0 1 .71h.37v-3.67h-.3a1.15 1.15 0 0 0-.61.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14027",
    "data-name": "Path 14027",
    className: "cls-2",
    d: "M18 12.37v1.85h.31a1 1 0 0 0 1-.52c.16-.27.17-.33.17-1.34s0-1.08-.15-1.29a1.08 1.08 0 0 0-1-.53H18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/ChatBot.7733d42dd1215a822bfff1ba5cf2691e.svg";
export { ForwardRef as ReactComponent };